'use client';

import { useLocalStorage } from '@mantine/hooks';
import { useEffect } from 'react';
import { setAdvent24Tuerchen } from '@/app/actions';

const defaultTuerchen: boolean[] = Array.from({ length: 24 }, () => false);
export const AdventskalenderAchievementTracker = () => {
    const [openedTuerchen] = useLocalStorage<boolean[]>({ key: 'adventskalender', defaultValue: defaultTuerchen });

    useEffect(() => {
        setAdvent24Tuerchen(openedTuerchen);
    }, [openedTuerchen]);

    return null;
};
